import React, { useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import TimbraturaCalendar from './timbratura_calendar';
import NoPermissions from '../authorization/NoPermissions';



const TimbraturaTabEmployee = ({ employee }) => {
    const { profile } = useContext(AuthContext);

    const hasPermission = (
      profile?.employee?.permissions.includes('hr.view_inouts_all') || 
      profile?.employee?.permissions.includes('hr.view_inouts_ou') ||
      profile?.employee?.permissions.includes('hr.manage_inouts_all') || 
      profile?.employee?.permissions.includes('hr.manage_inouts_ou')
    );  
  
    if (profile.customer_type === 'employee' && !hasPermission) {
      return <NoPermissions />;
    }

    return (
      <div>
        <div className="pt-2 pb-4">
          <TimbraturaCalendar employeeId={employee} />
        </div>

      </div>
    );
  };
      

export default TimbraturaTabEmployee;


    
